import {
  Box,
  Card,
  Typography,
  Button,
  Divider
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import Noevent from "../../../Assets/css/Community/NoEvents.webp";
import SidebarEventCard from "../Community/Events/SidebarEventCard";
import { useNavigate } from "react-router-dom";


const UpcomingEventsSidebar = () => {
  const [showAllEvents, setShowAllEvents] = useState(false);
  const navigate=useNavigate('')

  const registeredAttendees = useSelector(
    (state) => state.community.registeredAttendees
  );
  const events = useSelector((state) => state.community.events);

  const sortedAttendees = Array.isArray(registeredAttendees)
    ? [...registeredAttendees].sort(
      (a, b) => new Date(b.start_time) - new Date(a.start_time)
    )
    : [];

  // Get only the first two upcoming events
  const firstTwoEvents = sortedAttendees?.slice(0, 2);
  
  // Debug logging
  // console.log("sortedAttendees length:", sortedAttendees?.length);
  // console.log("firstTwoEvents:", firstTwoEvents);
  // console.log("showAllEvents:", showAllEvents);

  const showFilteredEvents = sortedAttendees?.length <= 10;
  
  const filteredEvents = showFilteredEvents && Array.isArray(events)
    ? events.filter((e) => e.is_my_event === false).slice(0, 10)
    : [];

  const handleViewAllEvents = () => {
    navigate('/community?tab=fourth')
  };

  const handleShowLess = () => {
    setShowAllEvents(false);
  };

  return (
    <Box
      sx={{
        height: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <Card
        sx={{ flex: 1, maxHeight: "55vh", display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ flex: 1, overflowY: "auto", scrollbarWidth: "none" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
            }}
          >
            {sortedAttendees?.length === 0 && filteredEvents?.length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  mt: 2,
                }}
              >
                <img width={"20%"} src={Noevent} alt="No Events" />
                <Typography color="text.secondary" variant="body2" mt={1}>
                  No booked events.
                </Typography>
              </Box>
            ) : (
              <>
                {/* Show Booked Events if available */}
                {sortedAttendees?.length > 0 && (
                  <>
                    <Typography
                      sx={{
                        fontSize: "18px",
                        padding: "10px",
                        fontWeight: "bold",
                        width: "100%",
                        textAlign: "left"
                      }}
                    >
                      Upcoming Events
                    </Typography>
                    
                    {/* Show either first two events or all events based on state */}
                    {(showAllEvents ? sortedAttendees : firstTwoEvents)?.map((event) => (
                      <SidebarEventCard key={event.id} event={event} />
                    ))}
                    
                    {/* Show "View All Events" button if there are more than 2 events and not showing all */}
                    {sortedAttendees?.length > 2 && !showAllEvents && (
                      <Button
                        onClick={handleViewAllEvents}
                        fullWidth
                        sx={{
                          mt: 2,
                          mb: 2,
                          mx: 2,
                          width: "calc(100% - 32px)",
                          textTransform: "none",
                          fontWeight: "medium",
                          borderRadius: "8px",
                          py: 1
                        }}
                      >
                        View All Events
                      </Button>
                    )}
                    
                    {!showAllEvents && sortedAttendees?.length > 2 && (
                      <Divider sx={{ width: "100%", my: 1 }} />
                    )}
                  </>
                )}
              </>
            )}
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default UpcomingEventsSidebar;